<template>
  <div>
    <div class="wz-page-header">
      <h1 class="wz-page-title">{{ editing ? 'Editar línea de gasto' : 'Nueva línea de gasto' }}</h1>
    </div>

    <form @submit.prevent="save" novalidate>
      <wz-card :title="editing ? 'Datos de la línea de gasto' : 'Datos de la nueva línea de gasto'">
        <div class="flex flex-wrap -mx-2">
          <div v-if="editing" class="w-full md:w-1/2 mb-3 px-2">
            <wz-input label="Código" :disabled="true" v-model="form.code" />
          </div>
          <div class="w-full md:w-1/2 mb-3 px-2">
            <wz-input label="Nombre" required v-model="form.name" placeholder="Nombre"
              :error="$v.form.name.$error && !$v.form.name.required ? 'Nombre es requerido' : ''" />
          </div>
          <div class="w-full mb-3 px-2" :class="{ 'md:w-1/2': !editing }">
            <wz-input label="Descripción" v-model="form.description" placeholder="Descripción" />
          </div>
        </div>

        <div class="flex justify-end gap-2 mt-2">
          <wz-button type="button" variant="light" @click="$router.push({ name: 'expense-line-list' })">{{ editing ? 'Volver' : 'Cancelar' }}</wz-button>
          <wz-button type="submit" variant="primary" class="ml-2">Guardar</wz-button>
        </div>
      </wz-card>
    </form>
  </div>
</template>

<script>
import { Alert } from "@wizepe/wizeui"
import { ExpenseLineService } from '@/core/services'
import { required } from 'vuelidate/lib/validators'

export default {
  data() { return { form: { code: null, name: null, description: null }, editing: false } },
  validations: { form: { name: { required } } },
  watch: { '$route.params.id'() { if (this.$route.params.id) this.load(this.$route.params.id) } },
  methods: {
    async save() {
      this.$v.$touch()
      if (this.$v.$error) return
      try {
        this.$store.dispatch('app/loading', true)
        let response
        if (!this.editing) response = await ExpenseLineService.save(this.form)
        else response = await ExpenseLineService.update(this.$route.params.id, this.form)
        Alert.success('Se almacenó la información correctamente')
        if (!this.editing) { this.$router.push({ name: 'expense-line-edit', params: { id: response.payload.id } }); this.editing = true }
      } catch (ex) { console.error(ex); Alert.error(ex.errors ? ex.errors.message : 'Error al guardar') }
      finally { this.$store.dispatch('app/loading', false) }
    },
    async load(id) {
      try {
        this.$store.dispatch('app/loading', true)
        this.form = { ...(await ExpenseLineService.get(id)).payload }
        this.editing = true
      } catch (e) { console.error(e); Alert.error(e.errors ? e.errors.message : 'Error al cargar'); this.$router.push({ name: 'expense-line-list' }) }
      finally { this.$store.dispatch('app/loading', false) }
    },
  },
  created() { if (this.$route.params.id) this.load(this.$route.params.id) },
}
</script>
